export default __webpack_public_path__ + "static/media/red-circle-xmark.65727f05f4009a61e7a067d63b1a8b2e.png";